<span>
  <i #spinner class="fa fa-circle-o-notch fa-spin fa-lg fa-fw spinner-style" aria-hidden="true"></i>
</span>